/// <reference path="../../Models/CertificateContainerModel.ts"/>
/// <reference path="../../Controls/CertificateGrid/CertificateGrid.ts"/>

module EEX.McEc {

    export module Apps {
        import SaveCertificateResult = McEc.Domain.SaveCertificateResult;
        import CertificateRevokeRequest = McEc.Domain.CertificateRevokeRequest;
        import RevokeCertificateResult = McEc.Domain.RevokeCertificateResult;
        import WindowOptions = AppKitchen.UIHelper.Windows.WindowOptions;
        import UserInfo = AppKitchen.Api.Models.UserInfo;
        import Data = kendo.data;
        import CertificateModel = McEc.Domain.CertificateModel;
        import CertificateGridModel = McEc.Controls.CertificateGrid.CertificateGridModel;
        import CertificateFileRequest = McEc.Domain.CertificateFileRequest;
        import CertificateContainer = McEc.Models.CertificateContainer;
        import CertificateContainerModel = McEc.Models.CertificateContainerModel;
        import CertificateGridHelper = McEc.Controls.CertificateGrid.CertificateGridHelper;

        // ReSharper disable once InconsistentNaming
        export interface ServerCertificatesAppOptions extends AppKitchen.AppBaseOptions {
            serverCertificateCreateDialog: AppKitchen.FrameManager.RoutedApp<ServerCertificateCreateDialogOptions>,
            certificateDownloadDialog: AppKitchen.FrameManager.RoutedApp<CertificateDownloadDialogOptions>,
            authorityId: string,
        }

        export class ServerCertificatesApp extends AppKitchen.AppBase<ServerCertificatesAppOptions> {

            private gridModel: CertificateGridModel;
            private gridView: AppKitchen.Controls.Grids.GridView;

            private serverCertificateCreateDialog: kendo.ui.Window;
            private certificateDownloadDialog: kendo.ui.Window;

            private certificateContainerModel: CertificateContainerModel;

            private userInfo: UserInfo;

            private containers: {
                list: HTMLElement,
            }

            private buttons: {
                createServerCertificate: JQuery,
            }

            public start() {
                this.certificateContainerModel = new CertificateContainerModel();

                AppKitchen.UIHelper.renderTemplateTo(this.el, McEc.Templates.ServerCertificates);

                this.containers = {
                    list: this.$el.find(".eex-mcec-certificate-list-content-container")[0]
                }

                this.buttons = {
                    createServerCertificate: this.$el.find(".eex-mcec-create-server-certificate-btn")
                }
                this.buttons.createServerCertificate.hide();

                this.loadAndCreateCertificateList();

                this.loadCurrentUser(() => {
                    this.setButtonAction();
                });
            }

            private loadCurrentUser(success: () => void) {
                AppKitchen.Data.Api.getUserInfo((userInfo: UserInfo) => {
                    this.userInfo = userInfo;
                        success();
                    },
                    (requestData, xhr) => {
                        AppKitchen.UIHelper.Notifications.notify(xhr.responseText, "warning");
                    });
            }

            private setButtonAction() {
                //if (this.userInfo.IsServerCertApplier) {
                    this.buttons.createServerCertificate.show();
                    this.buttons.createServerCertificate.click(() => {
                        this.openServerCertificateCreateDialog(this.userInfo);
                    }); 
                //}
            }

            private loadAndCreateCertificateList() {
                let gridConfig = CertificateGridHelper.getServerCertificateGridItem();
                this.gridModel = new CertificateGridModel(gridConfig, this.onDownload.bind(this), this.onRevoke.bind(this));

                this.gridView = new AppKitchen.Controls.Grids.GridView(this.gridModel,
                    this.containers.list,
                    {
                        fillHeight: true,
                        groupable: false,
                        sortable: true,
                        filterable: true,
                        noRecordsMessage: McEc.Strings.Grid_NoRecords,
                        lazyShow: { initial: 200, more: 80 },
                        headerTooltip: true,
                        initialSort: {
                            field: "CreatedDate",
                            dir: "desc"
                        },
                        templates: [
                            {
                                field: "CreatedDate",
                                template: (data) => {
                                    return this.parseDate(data["CreatedDate"]);
                                }
                            },
                            {
                                field: "NotBefore",
                                template: (data) => {
                                    return this.parseDate(data["NotBefore"]);
                                }
                            },
                            {
                                field: "NotAfter",
                                template: (data) => {
                                    return this.parseDate(data["NotAfter"]);
                                }
                            },
                            {
                                field: "State",
                                template: (data) => {
                                    return Helper.getLabelForStatus(data["State"]);
                                }
                            }
                        ]
                    });

                this.loadAndUpdateGridData();
            }

            private parseDate(date: string): string {
                if (this.isDateEmpty(date)) {
                    return "--";
                } else {
                    return kendo.toString(new Date(date), "G");
                }
            }

            private isDateEmpty(date: string): boolean {
                return date === "0001-01-01T00:00:00";
            }

            private updateGridData() {
                let certificates = this.certificateContainerModel.getCertificates();
                this.gridModel.set({ data: certificates });
            }

            private loadAndUpdateGridData() {
                new McEc.Data.Provider.ServerCertificatesProvider().load()
                    .then(certificates => this.certificatesLoaded(certificates))
                    .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
            }

            private certificatesLoaded(certificates: CertificateModel[]) {
                this.certificateContainerModel.updateAll(certificates);
                this.updateGridData();
                setTimeout(() => {
                    this.loadAndUpdateGridData();
                }, 5000);
            }

            private onDownload(e: any) {
                let certificateKey = this.getCertificateKeyFromButtonClick(e);
                if (certificateKey) {
                    new McEc.Data.Provider.CertificateFileProvider().load({ CertificateKey: certificateKey })
                        .then(certificateFile => this.certificateFileDownloaded(certificateKey, certificateFile))
                        .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
                }
            }

            private certificateFileDownloaded(certificateKey: number, certificateFile: string) {
                let store: Pki.Store = null;
                let cc = this.certificateContainerModel.findByKey(certificateKey);
                if (cc) {
                    store = cc.store;
                }
                this.openCertificateDownloadDialog(this.userInfo, certificateKey, store, certificateFile);
            }

            private onRevoke(e: any) {
                let certificateKey = this.getCertificateKeyFromButtonClick(e);
                AppKitchen.UIHelper.DialogBoxes.yesNo(kendo.format(Strings.Grid_RevokeCertificate_Text, certificateKey),
                    () => this.revokeCertificate(certificateKey),
                    () => { },
                    Strings.Grid_RevokeCertificate);
            }

            private revokeCertificate(certificateKey: number) {
                if (certificateKey) {
                    new McEc.Data.Provider.CertificateRevokeProvider().revoke({ CertificateKey: certificateKey })
                        .then(result => this.showNotification(result))
                        .fail(message => AppKitchen.UIHelper.Notifications.notify(message, "warning"));
                }
            }


            private showNotification(result: RevokeCertificateResult) {
                if (result.Ok) {
                    AppKitchen.UIHelper.Notifications.notify(McEc.Strings.CertificatesListe_Revoke_Ok,
                        "success",
                        { closeAfter: 3000 });
                } else {
                    AppKitchen.UIHelper.Notifications.notify(`${McEc.Strings.CertificatesListe_Revoke_Error} ${result.ErrorMessage}`,
                        "warning",
                        { closeAfter: 3000 });
                }
            }

            private getCertificateKeyFromButtonClick(e: any): number {
                let row = e.currentTarget.parentElement.parentElement;
                let dataItem = this.gridView.grid.dataItem(row);
                let certificateKey = dataItem["Key"];
                return certificateKey;
            }

            private openServerCertificateCreateDialog(userInfo: UserInfo) {
                var appOptions = {
                    close: this.closeServerCertificateCreateDialog.bind(this),
                    userInfo: userInfo,
                    authorityId: this.options.authorityId
                };
                let title = McEc.Strings.CertificateDialog_ServerCertificateCreateDialog_Title;
                var windowOptions: WindowOptions = {
                    title: title,
                    buttons: [
                        { name: "close", action: (window) => window.close() }
                    ],
                    modal: true,
                    easyClose: false,
                    width: "50em",
                    height: "30em"
                };

                // open window
                if (this.options.serverCertificateCreateDialog) {
                    this.serverCertificateCreateDialog = this.options.serverCertificateCreateDialog.startInWindow(windowOptions, appOptions);
                }
            }

            private closeServerCertificateCreateDialog(certificateKey: number, store: Pki.Store, certificateFile: string) {
                if (this.serverCertificateCreateDialog) {
                    this.serverCertificateCreateDialog.close();
                    if (certificateKey && store && certificateFile) {
                        this.certificateContainerModel.updateByKey(certificateKey, store, certificateFile);
                        this.updateGridData(); 
                    }
                }
            }

            private openCertificateDownloadDialog(userInfo: UserInfo, certificateKey: number, store: Pki.Store, certificateFile: string) {
                var appOptions = {
                    userInfo: userInfo,
                    authorityId: this.options.authorityId,
                    certificateKey: certificateKey,
                    store: store,
                    certificateFile: certificateFile,
                    close: this.closeCertificateDownloadDialog.bind(this)
                };
                var windowOptions: WindowOptions = {
                    title: McEc.Strings.CertificateDialog_CertificateDownloadDialog_Title,
                    buttons: [
                        { name: "close", action: (window) => window.close() }
                    ],
                    modal: true,
                    easyClose: false,
                    width: "50em",
                    height: "30em"
                };

                // open window
                if (this.options.certificateDownloadDialog) {
                    this.certificateDownloadDialog = this.options.certificateDownloadDialog.startInWindow(windowOptions, appOptions);
                }
            }

            private closeCertificateDownloadDialog(certificateKey: number, store: Pki.Store, certificateFile: string) {
                if (this.certificateDownloadDialog) {
                    this.certificateDownloadDialog.close();
                    if (certificateKey && store && certificateFile) {
                        this.certificateContainerModel.updateByKey(certificateKey, store, certificateFile);
                        this.updateGridData();
                    }
                }
            }
        }
    }
}